export default __webpack_public_path__ + "static/media/Orbitron-Bold.a0309d1f.ttf";